import axios from "axios";
import { useEffect } from "react";
import styles from "./Login.module.css";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { saveTokenTask } from "../../../redux/userSlice";

function Login() {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [email, setEmail] = useState("test@hack.com");
  const [password, setPassword] = useState("123456");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (user.info.token) {
      navigate("/");
    }
    // eslint-disable-next-line
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_API_URL}/users/tokens`,
        method: "POST",
        data: { email, password },
      });
      if (response && user.products.length > 0) {
        dispatch(saveTokenTask(response.data));
        navigate("/checkout");
      } else {
        dispatch(saveTokenTask(response.data));
        navigate("/");
      }
    } catch (error) {
      setMessage(error.response.data.msg);
    }
  };

  return (
    <div className={styles.body_background}>
      <div className="container">
        <div className={styles.row + " row"}>
          <div className={styles.leftCol + " col"}></div>
          <div className={styles.rightCol + " col"}>
            <Link className={styles.home_link} to="/">
              <p>
                <i className="me-1 fa-solid fa-arrow-left-long"></i>Home
              </p>
            </Link>
            <div className={styles.formLogin}>
              <form className="p-2 mb-1" action="" onSubmit={handleSubmit}>
                <h3
                  className={styles.login_title + " modal-title"}
                  id="formModalLabel"
                >
                  Login
                </h3>
                <p>A smooth sea never made a skillful sailor</p>
                <div className="form-group mt-2">
                  <input
                    value={email}
                    type="email"
                    name="email"
                    className={styles.form_font + " form-control"}
                    placeholder="Email"
                    onChange={(event) => setEmail(event.target.value)}
                  />
                </div>
                <div className="form-group mt-3">
                  <input
                    value={password}
                    type="password"
                    name="password"
                    className={styles.form_font + " form-control"}
                    id="password"
                    placeholder="Password"
                    onChange={(event) => setPassword(event.target.value)}
                  />
                  <p className={styles.errorMessage + " pt-3"}>{message}</p>
                </div>
                <button
                  style={{ color: "white" }}
                  type="submit"
                  className="btn mt-1"
                >
                  Login
                </button>
              </form>
              <p className={styles.linkToRegister}>
                Don't have an account?{" "}
                <span>
                  <Link className={styles.signup} to="/register">
                    Sign up
                  </Link>
                </span>
              </p>
            </div>
            <div className={styles.usertest}>
              <p
                style={{ fontWeight: "bold", fontSize: "18px" }}
                className="mb-1"
              >
                Possible user
              </p>
              <span className="text-center">
                To simplify access to the app, the following user account is
                provided
              </span>
              <span className={styles.email}>
                E-mail:<span className={styles.value}> test@hack.com</span>
              </span>
              <span>
                Password: <span className={styles.value}> 123456</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
